import { useEffect, useState } from "react";
import axios from "axios";
import styles from "../../BorrowerDetails.module.css";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BiEdit } from "react-icons/bi";
import { AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import userPlaceHolder from "../../../../../assets/userplaceholder.png";
import { url } from "../../../../../App";
import { useBorrowerContext } from "../../store/borrower-details";
import ProfileDetailsModal from "../Modals/ProfileDetailsModal";
import AddressDetailsModal from "../Modals/AddressDetailsModal";
import ApplicantFamilyDetailsModal from "../Modals/ApplicantFamilyDetailsModal";
// import ViewBorrowerDoc from "../SectionThree/ViewBorrowerDoc";
import Cookies from "js-cookie";
import CallIcon from "@mui/icons-material/Call";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip";
import ReplayIcon from "@mui/icons-material/Replay";
import { TextField } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewLoanDoc from "../SectionThree/ViewLoanDoc";
import PlaceIcon from '@mui/icons-material/Place';
import {
  Modal,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const SectionOne = ({
  disableContext,
  openLoader,
  closeLoader,
  permission,
}) => {
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  console.log(fetchedBorrowerDetails);
  // console.log(borrower?.borrower_credit_score)
  const fetchedLoanDetails = borrowerData.loan;
  const fetchedCoappDetails = borrowerData.coapplicant;
  const Navigate = useNavigate();
  const borrower = borrowerData.borrower;
  console.log(borrower);
  const loanTatTemp = borrowerData.loanTat;
  const { loanid } = useParams();
  // console.log(loanid, 'loanID')
  const [borrowerSelfie, setBorrowerSelfie] = useState({
    doc: "",
    type: "",
    exist: false,
  });
  const [isEmpty, setIsEmpty] = useState({
    profile: false,
    address: false,
    reference: false,
    applicant: false,
    professional: false,
    surrogate: false,
    obligation: false,
    bank: false,
  });
  const [profileDetailsModal, setProfileDetailsModal] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [applicantModal, setApplicantModal] = useState(false);
  const [enlargeSelfie, setEnlargeSelfie] = useState(false);
  const [loanTat, setLoanTat] = useState(0);
  const [userMobile, setuserMobile] = useState("");
  const [userName, setuserName] = useState("");
  const [statusModal, setstatusModal] = useState(false);
  const [borrowerPhoneNumber, setBorrowerPhoneNumber] = useState("");
  const [borrowerName, setBorrowerName] = useState("");
  // eslint-disable-next-line
  const [otp, setOtp] = useState(false);
  const [otpVerification, setOtpVerification] = useState(false);
  // eslint-disable-next-line
  const [borrowerId, setBorrowerId] = useState("");
  const [vendorCalling, setVendorCalling] = useState(null);
  const [cibilModal, setCibilModal] = useState(false);
  const [docName, setDocName] = useState("");
  const [title, setTitle] = useState("");
  const [modalType, setModalType] = useState("");
  const [loanDetails, setLoanDetails] = useState(null);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [callPurpose, setCallPurpose] = useState("");
  const [docExist, setDocExist] = useState({
    cibilReport: false,
  });
  const [camCibilScore, setCamCibilScore] = useState("");
  const [loanData, setLoanData] = useState("");
  const [latitude,setlatitude]=useState(null);
  const [longitude,setlongitude]=useState(null);

  const CibilDoc = [
    {
      name: "Cibil Report",
      exist: docExist.cibilReport,
      apiName: "loan_cibil_report",
      modalType: "multi",
      isRequired: true,
    },
  ];

  useEffect(() => {
    // const fetchSelfie = async () => {
    //   try {
    //     setLoanTat(loanTatTemp);
    //     if (borrower.borrower_selfphoto) {
    //       openLoader();
    //       //eslint-disable-next-line
    //       const finalIndex = borrower.borrower_selfphoto.length - 1;
    //       const finalDocName = borrower.borrower_selfphoto?.doc_name;
    //       const finalDocType = borrower.borrower_selfphoto?.doc_type;
    //       const req = {
    //         borrower_uniqueno: localStorage.getItem("uniqueID"),
    //         doc_name: finalDocName,
    //         doc_type: finalDocType,
    //         token: Cookies.get("Token"),
    //         email: Cookies.get("Email"),
    //       };
    //       const res = await axios.post(url + "/borrower/viewdoc", req);
    //       // console.log(res.data);
    //       closeLoader();
    //       if (!res.data.auth) {
    //         return setBorrowerSelfie({
    //           exist: false,
    //         });
    //       }
    //       setBorrowerSelfie((prevState) => ({
    //         ...prevState,
    //         doc: res.data.doc_base64,
    //         type: req.doc_type,
    //         exist: true,
    //       }));
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };

    const fetchSelfie = async () => {
      try {
        setLoanTat(loanTatTemp);
        const reqData = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          loan_id: loanid,
        };

        let loanData = await axios.post(url + "/loan/getsingle", reqData);
        // console.log(loanData, 'loandata');
        if (loanData.data.length > 0) {
          let loan = loanData.data[0];
          // console.log(loan, 'actual loan');
          setLoanData(loan);
          if (loan.self_photo) {
            openLoader();
            //eslint-disable-next-line
            const finalIndex = loan.self_photo.length - 1;
            const finalDocName = loan.self_photo[0]?.doc_name;
            const finalDocType = loan.self_photo[0]?.doc_type;
            const req = {
              borrower_uniqueno: localStorage.getItem("uniqueID"),
              loan_id: loanid,
              doc_name: finalDocName,
              doc_type: finalDocType,
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
            };
            const res = await axios.post(url + "/loan/viewdoc", req);
            // console.log(res.data);
            closeLoader();
            if (!res.data.auth) {
              return setBorrowerSelfie({
                exist: false,
              });
            }
            setBorrowerSelfie((prevState) => ({
              ...prevState,
              doc: res.data.doc_base64,
              type: req.doc_type,
              exist: true,
            }));
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
    const checkProfile = () => {
      const requiredFields = [
        "borrower_title",
        "borrower_gender",
        "borrower_firstname",
        "borrower_lastname",
        "borrower_dob",
        "borrower_maritalstatus",
        "borrower_residencetype",
        "borrower_education",
        "borrower_professiontype",
        "borrower_mobile",
        "borrower_email",
        "borrower_fathername",
        "borrower_mother_maiden",
        "borrower_motherTongue",
        "borrower_category",
        "borrower_religion",
        "borrower_familyStructure",
        "borrower_totalFamilyMembers",
        "borrower_companycode",
        "borrower_branchcode",
        "borrower_sourcecode",
      ];
      const profileIsEmpty = requiredFields.some((field) => !borrower[field]);

      setIsEmpty((prevState) => ({
        ...prevState,
        profile: profileIsEmpty,
      }));
    };

    const checkApplicant = () => {
      const requiredFields = [
        "name",
        "relationship",
        "age",
        "occupation",
        "phone",
      ];

      const applicationIsEmpty =
        borrower &&
        Array.isArray(borrower.borrower_applicant_family_details) &&
        borrower.borrower_applicant_family_details.some((applicant) =>
          requiredFields.some((field) => !applicant[field])
        );

      setIsEmpty((prevState) => ({
        ...prevState,
        applicant: applicationIsEmpty,
      }));
      // console.log(applicationIsEmpty)
    };

    fetchSelfie();
    checkProfile();
    checkApplicant();

    axios
      .post(url + "/user/getsingle", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        useremail: Cookies.get("Email"),
      })
      .then((res) => {
        // console.log(res);
        setuserMobile(res.data[0].staff_mobile);
        setuserName(res.data[0].staff_name);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(url + "/vendor/view", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      .then((res) => {
        if (res.data.auth && res.data.message.vendorCalling) {
          console.log(res.data.message);
          setVendorCalling(res.data.message.vendorCalling);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch vendor calling data.");
      });

    // eslint-disable-next-line
  }, [borrower]);

  useEffect(() => {
    const fetchedLoanDetails = borrowerData.loan;

    const foundLoan = fetchedLoanDetails.find(
      (item) => item.loan_id === loanid
    );
    setLoanDetails(foundLoan);
    
    setDocExist((prev) => ({
      ...prev,
      cibilReport: foundLoan?.loan_cibil_report?.length > 0,
    }));
    axios.post(url+'/videosdk/getlatlong',{
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId:loanid
    }).then((res)=>{
      console.log("res-> ",res.data)
      setlatitude(res.data.message.videosdk_latitude)
      setlongitude(res.data.message.videosdk_longitude)
    }).catch((err)=>{
      console.log("error-> ",err)
    })
  }, [borrowerData, loanid,latitude,longitude]);

  console.log(loanDetails, "loans");

  useEffect(() => {
    axios
      .post(url + "/cam/get/cam/data", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loanId: loanid,
      })
      .then((res) => {
        const lastCibilScore =
          res.data.borrower_bureau?.at(-1)?.cibilScore ?? "NA";
        // console.log(res.data.borrower_bureau);
        // console.log(lastCibilScore);
        setCamCibilScore(lastCibilScore);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [loanid]);

  useEffect(() => {
    // console.log(borrower)
    if (otpVerification) {
      openLoader();
      //  console.log("OTP verified, calling API...");
      axios
        .post(url + "/loan/regenerate/credit/score", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          loan_id: loanDetails?.loan_id,
          otp_status: "verified",
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth) {
            closeLoader();
            toast.success(res.data.message);
            setstatusModal(false);
            setBorrowerPhoneNumber("");
            axios
              .post(url + "/borrower/borrowertoalldetails", {
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
                borrower_uniqueno: localStorage.getItem("uniqueID"),
              })
              .then((res) => {
                updateBorrowerData((prevState) => ({
                  ...prevState,
                  borrower: res.data.message.borrower,
                }));
              })
              .catch((error) => {
                console.log("Error updating borrower details:", error);
                toast.error("Failed to update borrower details.");
              })
              .finally(() => {
                closeLoader();
              });
          } else {
            closeLoader();
            toast.error(res.data.message);
            setstatusModal(false);
            setBorrowerPhoneNumber("");
          }
        })
        .catch((error) => {
          closeLoader();
          console.log(error);
          toast.error("Failed to regenerate credit score.");
        });
    }
    // eslint-disable-next-line
  }, [otpVerification]);

  const closeProfileModal = () => {
    setProfileDetailsModal(false);
  };
  const openProfileModal = () => {
    setProfileDetailsModal(true);
  };

  const closeAddressModal = () => {
    setAddressModal(false);
  };

  const openApplicantModal = () => {
    setApplicantModal(true);
  };
  const closeApplicantModal = () => {
    setApplicantModal(false);
  };

  const enlargeSelfieHandler = () => {
    setEnlargeSelfie(true);
  };

  const closeEnlargeSelfie = () => {
    setEnlargeSelfie(false);
  };

  const handleCall = () => {
    const confirmCall = window.confirm("Do you want to call the customer?");
    if (!confirmCall) {
      toast.error("Call cancelled by the user.");
      return;
    }

    if (!vendorCalling) {
      toast.error("Vendor calling info not available.");
      return;
    }

    setOpenCallModal(true);
  };

  const handleConfirmCall = () => {
    if (!callPurpose) {
      toast.error("Please select call purpose.");
      return;
    }

    const payload = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      fromNumber: userMobile,
      // toNumber: borrower.borrower_mobile,
      toNumber: loanDetails.mobile,
      referenceNumber: uuidv4(),
      borrower_ID: borrower.borrower_uniqueno,
      customer_Name: userName,
      call_purpose: callPurpose,
      loan_id: loanid,
    };

    let apiEndpoint = "";

    if (vendorCalling === "Knowlarity") {
      apiEndpoint = url + "/Knowlarity/call/api";
    } else if (vendorCalling === "Kalerya") {
      apiEndpoint = url + "/customer/call";
    } else {
      toast.error("Invalid vendor calling configuration.");
      return;
    }

    axios
      .post(apiEndpoint, payload)
      .then((res) => {
        if (res.data.auth) {
          toast.success(res.data.message);
          setOpenCallModal(false);
          setCallPurpose("");
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to initiate call.");
      });
  };

  const regenerateCreditScore = async (status) => {
    try {
      const res = await axios.post(url + "/loan/regenerate/credit/score", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loan_id: loanDetails?.loan_id,
        otp_status: status,
      });

      if (res.data.auth) {
        toast.success(res.data.message);

        const borrowerRes = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );

        updateBorrowerData((prevState) => ({
          ...prevState,
          borrower: borrowerRes.data.message.borrower,
        }));
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to regenerate credit score.");
    } finally {
      closeLoader();
    }
  };

  const handleCreditScore = async () => {
    openLoader();
    // console.log(borrower.borrower_credit_score_fetched_date);
    setBorrowerName(loanDetails?.borrower_name);
    if (!borrower?.borrower_credit_score_180days) {
      handleCibilOtp(loanDetails?.mobile);
      return;
    }

    const currentDate = new Date();
    const fetchedDate = new Date(borrower?.borrower_credit_score_180days);
    // console.log(currentDate);

    const daysDiff = Math.floor(
      (currentDate - fetchedDate) / (1000 * 60 * 60 * 24)
    );

    // console.log(daysDiff);

    if (daysDiff > 180) {
      handleCibilOtp(loanDetails?.mobile);
    } else {
      regenerateCreditScore("not verified");
    }
  };

  const handleCibilOtp = (phone) => {
    axios
      .post(url + "/user/lms/otp/send", {
        templateId: "6352612bd6fc0569c5696062",
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrowerMobile: phone,
        VAR1: borrowerName,
      })
      .then((res) => {
        closeLoader();
        toast.success("OTP Sent to +91 " + phone);

        setTimeout(() => {
          const otp = prompt("Please Enter OTP received at +91 " + phone);
          handleCibilVerify(otp, phone);
        }, 2000);
      })
      .catch((err) => {
        closeLoader();
        toast.error(err.message);
      });
  };

  const handleCibilVerify = (otp, phone) => {
    axios
      .post(url + "/user/lms/otp/verify", {
        borrowerOtp: otp,
        borrowerMobile: phone,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      .then((res) => {
        if (res.data.type === "success") {
          toast.success("OTP Verification Successful");

          regenerateCreditScore("verified");
        } else {
          toast.error("Invalid OTP Please Try Again");
        }
      })
      .catch((err) => {
        toast.error("OTP Verification Failed");
      });
  };

  if (statusModal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  const handleChangeBorrowerPhoneNumber = (e) => {
    if (e.target.value.length <= 10) {
      setBorrowerPhoneNumber(e.target.value);
    }
    if (e.target.value.length === 10) {
      setTimeout(() => {
        let text = "Send OTP on " + e.target.value + "?";
        if (window.confirm(text) === true) {
          // console.log(e.target.value);
          handleOtp(e.target.value);
        } else {
          toast.error("Please confirm your number for OTP Verification");
          return;
        }
      }, 1000);
    }
  };

  const handleOtp = (phone) => {
    openLoader();
    axios
      .post(url + "/user/lms/otp/send", {
        templateId: "6352612bd6fc0569c5696062",
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrowerMobile: phone,
        VAR1: borrowerName,
      })
      .then((res) => {
        closeLoader();
        toast.success("OTP Sent to +91 " + phone);
        // console.log(res.data);
        setTimeout(() => {
          const otp = prompt("Please Enter OTP received at +91 " + phone);
          // setOtp(d);
          handleVerify(otp, phone);
        }, 4000);
      })
      .catch((err) => {
        // console.log(err);
        closeLoader();
        toast.error(err.message);
      });
  };

  const handleVerify = (otp, phone) => {
    setOtp(otp);
    axios
      .post(url + "/user/lms/otp/verify", {
        borrowerOtp: otp,
        borrowerMobile: phone,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      .then((res) => {
        if (res.data.type === "success") {
          // console.log(res.data);
          toast.success("OTP Verification Successful");
          setOtpVerification(true);
        } else {
          toast.error("Invalid OTP Please Try Again");
          return;
        }
      })
      .catch((err) => {
        // console.log(err);
        toast.error(err);
      });
  };

  const cancelFunction = () => {
    setstatusModal(false);
    setBorrowerPhoneNumber("");
  };

  function CibilScoreCard({ score, openCibilReport, regenerateScore }) {
    // If score is not a number, default percentage to 0
    const isValidScore = !isNaN(score) && score !== "NA";
    const numericScore = isValidScore ? Number(score) : 0;
    const percentage = isValidScore
      ? ((numericScore - 300) / (900 - 300)) * 180
      : 0;

    return (
      <div style={{ marginTop: "0.5rem" }}>
        <div
          style={{ color: "gray", fontSize: "0.9rem", marginBottom: ".3rem" }}
        >
          <span>{"> "} CIBIL Score</span>
        </div>

        <div
          style={{ width: "180px", marginLeft: "0.2rem", marginTop: "-0.4rem" }}
        >
          <svg width="180" height="110">
            {/* Background Arc */}
            <path
              d="M20 100 A70 70 0 0 1 160 100"
              fill="none"
              stroke="#e6e6e6"
              strokeWidth="12"
            />

            {/* Foreground Arc */}
            <path
              d="M20 100 A70 70 0 0 1 160 100"
              fill="none"
              stroke={isValidScore ? "#1ec562" : "#cccccc"} // gray if NA
              strokeWidth="12"
              strokeDasharray={`${percentage * 2.45},1000`}
              strokeLinecap="round"
            />

            {/* Needle */}
            <line
              x1="90"
              y1="100"
              x2={90 + 60 * Math.cos((Math.PI / 180) * (180 - percentage))}
              y2={100 - 60 * Math.sin((Math.PI / 180) * (180 - percentage))}
              stroke="#394867"
              strokeWidth="3"
            />

            <circle cx="90" cy="100" r="4" fill="#394867" />

            <text
              x="90"
              y="90"
              textAnchor="middle"
              style={{
                fill: isValidScore ? "#1ec562" : "#999999",
                fontSize: "22px",
                fontWeight: 600,
              }}
            >
              {score}
            </text>
          </svg>
        </div>

        <div
         style={{ width: "180px", marginLeft: "0.2rem", marginTop: "1rem" }}
        >

     
        {permission.bureau_cam === true && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "3.5rem",
              marginTop: "-0.4rem",
            }}
          >
           {(latitude && longitude) && <Tooltip title="View Location">
              <PlaceIcon
                onClick={()=>{
                  window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank");
                }}
                style={{
                  cursor: "pointer",
                  color: "#394867",
                  fontSize: "22px",
                }}
              />
            </Tooltip>}
            {CibilDoc.map((doc, index) => (
              <Tooltip key={index} title="View CIBIL Report">
                <VisibilityIcon
                  onClick={() =>
                    doc.exist
                      ? viewBorrowerDocModal(
                          doc.apiName,
                          doc.name,
                          doc.modalType
                        )
                      : docDoesntExistHandler()
                  }
                  style={{
                    cursor: "pointer",
                    color: "#394867",
                    fontSize: "22px",
                  }}
                />
              </Tooltip>
            ))}

            <Tooltip title="Regenerate Credit Score">
              <ReplayIcon
                onClick={regenerateScore}
                style={{
                  cursor: "pointer",
                  color: "#394867",
                  fontSize: "22px",
                }}
              />
            </Tooltip>
          </div>
        )}
           </div>
      </div>
    );
  }

  const viewBorrowerDocModal = (docName, title, modalType) => {
    setDocName(docName);
    setTitle(title);
    setModalType(modalType);
    setCibilModal(true);
  };

  const closeBorrowerDocModal = () => {
    setDocName("");
    setTitle("");
    setModalType("");
    setCibilModal(false);
  };

  const docDoesntExistHandler = () => {
    toast.error("Document does not exist");
  };

  return (
    <>
      {/* {enlargeSelfie && (
        <ViewBorrowerDoc
          borrowerDetails={fetchedBorrowerDetails}
          openLoader={openLoader}
          doc={borrowerSelfie.doc}
          closeLoader={closeLoader}
          docType={borrowerSelfie.type}
          docName={"borrower_selfphoto"}
          title={
            <h3 style={{ fontSize: "15px", fontWeight: "bold" }}>
              Borrower Selfie
            </h3>
          }
          closeModal={closeEnlargeSelfie}
          modalType={"single"}
        />
      )} */}

      {enlargeSelfie && (
        <ViewLoanDoc
          loanDetails={loanDetails}
          docName="self_photo"
          title={
            <h3 style={{ fontSize: "15px", fontWeight: "bold" }}>
              Borrower Self Photo
            </h3>
          }
          closeModal={closeEnlargeSelfie}
          openLoader={openLoader}
          closeLoader={closeLoader}
          modalType={modalType}
        />
      )}

      {cibilModal && (
        <ViewLoanDoc
          loanDetails={loanDetails}
          docName={docName}
          title={title}
          closeModal={closeBorrowerDocModal}
          openLoader={openLoader}
          closeLoader={closeLoader}
          modalType={modalType}
          isDownload={permission.bureau_cam}
          isDelete={permission.delete_bureau_cam}
        />
      )}

      {applicantModal && (
        <ApplicantFamilyDetailsModal
          fetchedBorrowerDetails={fetchedBorrowerDetails}
          fetchedLoanDetails={fetchedLoanDetails}
          fetchedCoappDetails={fetchedCoappDetails}
          closeApplicantModal={closeApplicantModal}
        />
      )}

      {addressModal && (
        <AddressDetailsModal
          fetchedBorrowerDetails={fetchedBorrowerDetails}
          closeAddressModal={closeAddressModal}
        />
      )}

      {profileDetailsModal && (
        <ProfileDetailsModal
          fetchedBorrowerDetails={fetchedBorrowerDetails}
          closeProfileModal={closeProfileModal}
        />
      )}

      <div className={styles.sectionOne}>
        <div>
          <button
            onClick={() =>
              Navigate(`/single/borrower/details/${borrower.borrower_uniqueno}`)
            }
            className={styles.backIcon}
          >
            <ArrowBackIcon sx={{ fontSize: "28px" }} />
          </button>
        </div>
        <div className={styles.sectionOneContainer}>
          <img
            draggable={false}
            onContextMenu={disableContext}
            onClick={enlargeSelfieHandler}
            src={
              loanData.self_photo
                ? `data:image/${borrowerSelfie.type};base64,${borrowerSelfie.doc}`
                : userPlaceHolder
            }
            style={{ cursor: "pointer" }}
            // onClick={}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = userPlaceHolder;
            }}
            alt="not found"
            className={styles.profilePic}
          />
          <p className={styles.nameText}>{`${
            borrower.borrower_firstname ?? ""
          } ${borrower.borrower_middlename ?? ""} ${
            borrower.borrower_lastname ?? ""
          }`}</p>
          <p
            style={{
              fontSize: "1rem",
              color: "gray",
              marginBottom: "0.7rem",
            }}
          >
            {localStorage.getItem("uniqueID")}
            <span style={{ marginLeft: "5px" }}>
              {loanid ? `( ${loanid} )` : ""}
            </span>
          </p>
          <div
            style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}
          >
            <div>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "gray",
                  marginBottom: "0.5rem",
                }}
              >
                TAT - {loanTat} Days
              </p>
            </div>

            <div>
              <Tooltip title="Call the Customer">
                <CallIcon
                  style={{
                    cursor: "pointer",
                    color: "#034ea1",
                    fontSize: "28px",
                    paddingBottom: "10px",
                  }}
                  onClick={handleCall}
                />
              </Tooltip>
            </div>
          </div>

          {fetchedBorrowerDetails.borrower_aadhaar_mobile_link ===
            "Aadhaar not linked to mobile number" && (
            <p style={{ color: "red" }}>
              {fetchedBorrowerDetails.borrower_aadhaar_mobile_link}
            </p>
          )}

          <hr
            style={{
              backgroundColor: "gray",
              margin: "1rem",
              width: "100%",
            }}
          />
          <div className={styles.borrowerInformation}>
            <p
              style={{
                color: "#034ea1",
                fontWeight: "500",
                marginBottom: ".5rem",
                fontSize: "1.1rem",
              }}
            >
              Borrower Information
            </p>

            <div
              style={{
                color: "gray",
                fontSize: "0.9rem",
                marginBottom: ".3rem",
              }}
            >
              <span style={{ color: isEmpty.profile ? "red" : "" }}>
                {"> "}Personal Details
              </span>
              {/* <span style={{ marginLeft: "1rem", float: "right" }}> */}
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".4rem",
                  float: "right",
                }}
              >
                {permission.edit_borrower && (
                  <AiOutlineEye cursor="pointer" onClick={openProfileModal} />
                )}
                {permission.edit_borrower && (
                  <Link
                    to={`/edit/borrower/screen/${borrower.borrower_uniqueno}`}
                    state={borrower}
                  >
                    <BiEdit
                      style={{ marginLeft: ".3rem", color: "#949494" }}
                      cursor="pointer"
                    />
                  </Link>
                )}
              </span>
            </div>
            <div
              style={{
                color: "gray",
                fontSize: "0.9rem",
                marginBottom: ".3rem",
              }}
            >
              <span>
                {"> "}KYC Status:{" "}
                <span className="text-green-500">Verified</span>
              </span>
            </div>

            <div
              style={{
                color: "gray",
                fontSize: "1rem",
                marginBottom: ".3rem",
              }}
            >
              <span style={{ color: isEmpty.applicant ? "red" : "" }}>
                {"> "}Application Details
              </span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".4rem",
                  float: "right",
                }}
              >
                <AiOutlineEye cursor="pointer" onClick={openApplicantModal} />
                {permission.edit_loan_application && (
                <Link to={`/edit/new/loan/${loanid}`} state={borrower}>
                  <BiEdit
                    style={{ marginLeft: ".3rem", color: "#949494" }}
                    cursor="pointer"
                  />
                </Link>
                )}
              </span>
            </div>

            <div
              style={{
                color: "gray",
                fontSize: "0.9rem",
                marginBottom: ".3rem",
              }}
            ></div>
            <CibilScoreCard
              score={
                loanDetails?.credit_score > 0
                  ? loanDetails?.credit_score
                  : camCibilScore
              }
              openCibilReport={() => setCibilModal(true)}
              regenerateScore={handleCreditScore}
            />
          </div>
        </div>
        {statusModal && (
          <div className="modal overlay">
            <div className="status-content">
              <h4 style={{ width: "100%", textAlign: "center" }}>
                Verification
              </h4>
              <br />
              <form>
                <div className="lms-table-div-modal">
                  <div className="input-div">
                    <label>Mobile Number*</label>
                    <TextField
                      className="lms-input-field"
                      size="small"
                      variant="outlined"
                      id="ph-no"
                      required
                      placeholder="Phone Number"
                      value={borrowerPhoneNumber}
                      type="number"
                      onChange={handleChangeBorrowerPhoneNumber}
                      name="ph-no"
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: ".6rem",
                        },
                      }}
                    />
                  </div>
                  <br />
                  <br />
                </div>
                <button
                  className="cancel-modal"
                  type="button"
                  onClick={cancelFunction}
                >
                  Close
                </button>
              </form>
            </div>
          </div>
        )}

        <Modal
          open={openCallModal}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown")
              return;
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 350,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
            }}
          >
            <h3>
              Select Call Purpose<span style={{ color: "red" }}>*</span>
            </h3>

            <FormControl fullWidth size="small" sx={{ mt: 2 }}>
              <InputLabel>Call Purpose</InputLabel>
              <Select
                value={callPurpose}
                label="Call Purpose"
                onChange={(e) => setCallPurpose(e.target.value)}
              >
                <MenuItem value="TELE_PD">Tele PD</MenuItem>
                <MenuItem value="LOAN_VERIFICATION">Loan Verification</MenuItem>
                <MenuItem value="REFERENCE_CALL">Reference Call</MenuItem>
              </Select>
            </FormControl>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => {
                  setOpenCallModal(false);
                  setCallPurpose("");
                }}
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={handleConfirmCall}>
                Call
              </Button>
            </Box>
          </Box>
        </Modal>

        <ToastContainer />
      </div>
    </>
  );
};

export default SectionOne;
